import { cleanAxios } from '~/axios'

export interface VerifyMFACodeResult {
  successful: boolean
  content: 'SUCCESSFUL' | 'INVALID'
}

export async function verifyMFAEmailCode({
  email,
  code,
  rememberMe,
  accessToken,
}: {
  email: string
  code: string
  rememberMe: boolean
  accessToken: string
}) {
  return await cleanAxios.post<{
    data: { verifyMFAEmailCode: VerifyMFACodeResult }
  }>(
    '/graphql',
    {
      query:
        'query verifyMFAEmailCode($email: String!, $code: String!, $rememberMe: String!) { verifyMFAEmailCode(email: $email, code: $code, rememberMe: $rememberMe) { successful content } }',
      variables: { email, code, rememberMe: rememberMe ? 'yes' : 'no' },
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  )
}
